<template>
  <div class="game-room-page">
    <div style="background: linear-gradient(to bottom, #191b1c, #191b1c)">
      <div class="head-area">
        <div class="leftImg">
          <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
        </div>
        <div class="head_text">
          <span class="title">{{ title }}</span>
          <span class="status" @click="toggleGameList(true)">
            {{ totalSeconds > Number(room_info.youxi.qs_start_time) ?  $t('开盘中') : $t('已封盘')}}
            <img src="/static/image/new/game/arrow-white2.png" :class="{'arrow': true, 'open': isPageModal}" alt="">
          </span>
        </div>
        <span class="right_menu">
          {{ $t('余额') }}： <span class="money">{{ $store.state.userInfo.balance }}</span>
        </span>
      </div>
      <div class="lottery-box-bg">
        <ul class="select-game-list" v-if="isPageModal">
          <li v-for="(item,index) in game_list" :class="{'active': game_video === item.type && room === item.room}" @click="selectGameList(item)" :key="index">{{ item.name }}</li>
        </ul>
        <div class="lottery-box">
          <div class="top">
            <div class="top-left">
              <div class="lottery-period">{{sequence_info.sequencenum + 1}}{{ $t('期') }}</div>
              <div class="text">{{ totalSeconds > 0 ? (totalSeconds <= Number(room_info.youxi.qs_start_time) ? $t('封盘中') : $t('下注倒计时')) : $t('开奖中') }}</div>
            </div>
            <div class="top-right">
              <div class="lottery-num">{{ sequence_info.sequencenum }} {{ $t('期开奖结果') }}</div>
<!--              <div class="brand-status" @click="toggleBrand()">-->
<!--                <img src="/static/image/new/game/icon.png" class="icon" alt="">-->
<!--                {{ $t('咪牌') }}{{brand_status ? $t('已开启') : $t('已关闭')}}-->
<!--              </div>-->
            </div>
          </div>
          <div class="bottom">
            <div class="count-down">
<!--              <div class="hours-box">{{ hours }}</div>-->
              <div class="minute-box">{{ minute }}</div>
              <div class="second-box">{{ second }}</div>
            </div>
            <div class="lottery-results" v-if="sequence_info.outcome_arr">
              <div class="num blue-bg">{{ sequence_info.outcome_arr[0] }}</div>
              <div class="symbol">+</div>
              <div class="num blue-bg">{{ sequence_info.outcome_arr[1] }}</div>
              <div class="symbol">+</div>
              <div class="num blue-bg">{{ sequence_info.outcome_arr[2] }}</div>
              <div class="symbol">=</div>
              <div :class="['num', sequence_info.outcome_arr[3] >= 14 ? 'red-bg' : 'green-bg']">{{ sequence_info.outcome_arr[3] }}</div>
            </div>
            <img src="/static/image/new/game/blue-arrow.png" :class="{'arrow-more': true, 'rotate-arrow': !isDropList}" alt="" @click="toggleArrowMore">
          </div>
        </div>
      </div>
      <div class="nav-list">
        <div :class="{'nav-item': true, 'active': nav_type === item.id}" v-for="(item) in nav_list" :key="item.id" @click="clickNaTab(item.id, item.path)" v-if="item.isShow">{{item.name}}</div>
      </div>
    </div>
    <div class="content">
      <!--  开奖下拉框    -->
      <div class="list_drop_box" v-if="isDropList">
        <div class="table-head">
          <div class="td">{{ $t('期号') }}</div>
          <div class="td">{{ $t('号码') }}</div>
          <div class="td">{{ $t('总和') }}</div>
          <div class="td">{{ $t('总和两面') }}</div>
        </div>
        <div class="recode-table">
          <div class="table-list">
            <div class="tr" v-for="(item,index) in trend_list" :key="index">
              <div class="td">
                <div class="sequenceNum">{{ $t('第') }} {{ item.sequencenum }} {{ $t('期') }}</div>
                <div class="time">{{ formatDate(item.addtime, 'seconds') }}</div>
              </div>
              <div class="td">
                <div class="num-box">
                  <div class="num blue-bg">{{ item.outcome_arr[0] }}</div>+
                  <div class="num blue-bg">{{ item.outcome_arr[1] }}</div>+
                  <div class="num blue-bg">{{ item.outcome_arr[2] }}</div>=
                  <div :class="['num', item.outcome_arr[3] >= 14 ? 'red-bg' : 'green-bg']">{{ item.outcome_arr[3] }}</div>
                </div>
              </div>
              <div class="td">
                <div class="sum-info">
                  <span :class="[item.outcome_arr[3] >= 14 ? 'red-color' : 'blue-color']">{{item.outcome_arr[3] >= 14 ? $t('大') : $t('小')}}</span>
                  <span :class="[item.outcome_arr[3] % 2 === 1 ? 'blue-color' : 'red-color']">{{item.outcome_arr[3] % 2 === 1 ? $t('单') : $t('双')}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-container">
          <transition name="slide-up">
            <ul v-if="isPageModal" class="page-popup-menu">
              <li @click="selectPageSize(item)" v-for="(item,index) in size_list" :key="index">{{ item }}</li>
            </ul>
          </transition>
          <div class="select-page-size" @click="isPageModal = !isPageModal;">
            <div class="page-size">{{ $t('每页') }}{{page_size}}{{ $t('条') }}</div>
            <img src="/static/image/new/game/blue-arrow.png" :class="{'arrow': true, 'arrow-top': !isPageModal}" alt="">
          </div>
          <div class="page-box">
            <div class="page-btn" @click="page_first_init('trend')">{{ $t('首页') }}</div>
            <div class="page-btn" @click="page_pre_init('trend')">{{ $t('上一页') }}</div>
            <div class="line"></div>
            <div class="page-btn" @click="page_next_init('trend')">{{ $t('下一页') }}</div>
            <div class="page-btn" @click="page_last_init('trend')">{{ $t('尾页') }}</div>
          </div>
        </div>
      </div>
      <template v-else>
         <!--  投注区  -->
         <template v-if="nav_type === 1">
           <div class="msg-container">
             <div class="msg-list" ref="scrollContainer">
               <template v-for="(item,index) in chat_list">
                 <template v-if="item.role == 1 && item.room === room">
                   <template v-if="item.distinguish == 1">
                     <div class="msg-item" v-if="item.userid == room_info.userid">
                       <div class="left"></div>
                       <div class="right">
                         <div class="msg-content">
                           <div class="msg-text" v-html="item.content"></div>
                         </div>
                       </div>
                     </div>
                   </template>
                   <template v-else-if="item.distinguish == 0 || (item.distinguish == 2 && item.userid == room_info.userid)">
                     <div :class="{'msg-item': true, 'self-msg-item': item.userid === room_info.userid}">
                       <div class="left">
                         <img class="avatar" src="/static/image/new/game/logo.jpeg" alt="">
                       </div>
                       <div class="right">
                         <div class="msg-name">
                           <span>[{{ $t('投注成功') }}]</span>
                           <span style="color: #fff; font-size: .27rem;margin: 0 .1rem;">{{ formatDate(item.addtime, 'seconds') }}</span>
                         </div>
                         <div class="msg-content">
                           <div class="msg-text">
                             {{ $t('期号') }}：{{ item.sequencenum }}
                           </div>
                           <div class="msg-text">
                             {{ $t('用户') }}：{{ item.username }}
                           </div>
                           <div class="msg-text">
                             {{ $t('投注') }}：<span v-html="item.content"></span>
                           </div>
                           <div class="msg-text">
                             {{ $t('时间') }}：{{  formatDate(item.addtime, 'seconds') }}
                           </div>                         </div>
                       </div>
                     </div>
                   </template>
                 </template>
                 <div :class="{'msg-item': true, 'self-msg-item': item.userid === room_info.userid}" v-else-if="item.userid == room_info.userid && item.room == room">
                   <div class="left">
                     <img class="avatar" :src="item.headimgurl" v-if="item.headimgurl" alt="">
                     <img class="avatar" src="/static/image/new/game/default.png" v-else alt="">
                   </div>
                   <div class="right">
                     <div class="msg-name">
                       <span>{{ item.username }}</span>
<!--                       <span class="vip-box">-->
<!--                        <img src="/static/image/new/game/vip1.png" class="vip-icon" alt="">-->
<!--                        VIP1-->
<!--                       </span>-->
                     </div>
                     <div class="msg-content">
                       <div class="msg-time">{{ formatDate(item.addtime, 'seconds') }}</div>
                       <div class="msg-text" v-html="item.content"></div>
                     </div>
                   </div>
                 </div>
                 <div :class="{'msg-item': true, 'self-msg-item': item.userid === room_info.userid}" v-else>
                   <div class="left">
                     <img class="avatar" :src="item.headimgurl" v-if="item.headimgurl" alt="">
                     <img class="avatar" src="/static/image/new/game/default.png" v-else alt="">
                   </div>
                   <div class="right">
                     <div class="msg-name">
                       <span>[{{ $t('投注成功') }}]</span>
                       <span style="color: #fff; font-size: .27rem;margin: 0 .1rem;" v-if="item.role === 1">{{ formatDate(item.addtime, 'seconds') }}</span>
<!--                       <span class="vip-box" v-else>-->
<!--                        <img src="/static/image/new/game/vip1.png" class="vip-icon" alt="">-->
<!--                        VIP1-->
<!--                       </span>-->
                     </div>
                     <div class="msg-content">
                       <div class="msg-text">
                         {{ $t('期号') }}：{{ item.sequencenum }}
                       </div>
                       <div class="msg-text">
                         {{ $t('用户') }}：{{ item.username }}
                       </div>
                       <div class="msg-text">
                         {{ $t('投注') }}：<span v-html="item.content"></span>
                       </div>
                       <div class="msg-text">
                         {{ $t('时间') }}：{{  formatDate(item.addtime, 'seconds') }}
                       </div>
                     </div>
                   </div>
                 </div>
               </template>
             </div>
             <div class="footer">
               <div class="bet-box">
                 <button class="select-btn" type="button" @click="toggleMode(true)" :aria-label="$t('选择')">
                   <svg class="select-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                     <path d="M5 6h14M5 12h14M5 18h14" />
                   </svg>
                 </button>
                 <div class="bet-input">
                   <input type="text" :placeholder="$t('请输入')+'...'" v-model="send_val">
                 </div>
                 <div class="bet-btn" @click="sendMessage">{{ $t('下注') }}</div>
               </div>
             </div>
           </div>
         </template>
         <!-- 游戏记录   -->
         <div class="record-container" v-else-if="nav_type === 3">
           <div class="record-list">
             <div class="record-item" v-for="(item,index) in bet_list" :key="index">
               <div class="record-head">
                 <div class="left">
<!--                   <span>加拿大2.8</span>-->
                   <span>{{ $t('第') }}{{ item.sequencenum }}{{ $t('期') }}</span>
                 </div>
                 <div class="right" v-if="item.outcome_arr[3]">
                   {{ $t('开奖号码') }}:
                   <div class="num-box">
                     <div class="num">{{ item.outcome_arr[0] }}</div> +
                     <div class="num">{{ item.outcome_arr[1] }}</div> +
                     <div class="num">{{ item.outcome_arr[2] }}</div> =
                     <div :class="['num', item.outcome_arr[3] >= 14 ? 'red-bg' : 'green-bg']">{{ item.outcome_arr[3] }}</div>
                   </div>
                 </div>
               </div>
               <div class="record-content">
                 <div class="record-text">
                   <div class="label">{{ $t('投注时间') }}：</div>
                   <div class="value">{{ item.bet_time }}</div>
                 </div>
                 <div class="record-text">
                   <div class="label">{{ $t('投注金额') }}：</div>
                   <div class="value">{{ item.bet_money }}</div>
                 </div>
                 <div class="record-text">
                   <div class="label">{{ $t('玩法') }}：</div>
                   <div class="value">{{ item.content }}</div>
                 </div>
                 <div class="record-text">
                   <div class="label">{{ $t('状态') }}：</div>
                   <div class="value">
                     <div class="red-color">{{ $t(item.status) }}</div>
                   </div>
                 </div>
                 <div class="record-text">
                   <div class="label">{{ $t('盘类') }}：</div>
                   <div class="value">A</div>
                 </div>
                 <div class="record-text">
                   <div class="label">{{ $t('派奖奖金') }}：</div>
                   <div class="value">{{ item.reward }}</div>
                 </div>
                 <div class="record-text">
                   <div class="label">{{ $t('赔率') }}：</div>
                   <div class="value">0</div>
                 </div>
               </div>
             </div>
           </div>
           <div class="record-footer">
             <div class="total-info">
               <div class="info-item">
                 <div class="value">{{ bet_info.total_bet }}</div>
                 <div class="label">{{ $t('总投注') }}</div>
               </div>
               <div class="info-item">
                 <div class="value">{{ bet_info.valid_bet }}</div>
                 <div class="label">{{ $t('有效投注') }}</div>
               </div>
               <div class="info-item">
                 <div class="value">{{ bet_info.total_reward }}</div>
                 <div class="label">{{ $t('总盈利') }}</div>
               </div>
               <div class="info-item">
                 <div class="value red-color">{{ bet_info.total_reward }}</div>
                 <div class="label">{{ $t('实际盈利') }}</div>
               </div>
             </div>
             <div class="page-box">
               <div class="page-btn" @click="page_first_init('bet')">{{ $t('首页') }}</div>
               <div class="page-btn" @click="page_pre_init('bet')">{{ $t('上一页') }}</div>
               <div class="line"></div>
               <div class="page-btn" @click="page_next_init('bet')">{{ $t('下一页') }}</div>
               <div class="page-btn" @click="page_last_init('bet')">{{ $t('尾页') }}</div>
             </div>
           </div>
         </div>
          <!--    玩法介绍     -->
         <div class="game-introduce" v-else-if="nav_type === 4" v-html="getGameIntroduce()">
         </div>
         <!-- 开奖记录   -->
         <div class="lottery-container" v-else-if="nav_type === 6">
<!--         <div class="big-title">-->
<!--           10月22日开奖记录-->
<!--         </div>-->
         <div class="table-head">
           <div class="td">{{ $t('期号') }}</div>
           <div class="td">{{ $t('号码') }}</div>
           <div class="td">{{ $t('总和') }}</div>
           <div class="td">{{ $t('两面') }}</div>
           <div class="td">{{ $t('组合') }}</div>
         </div>
         <div class="recode-table">
           <div class="table-list">
             <div class="tr" v-for="(item,index) in history_list" :key="index">
               <div class="td">
                 <div class="sequenceNum">{{ $t('第') }}{{ item.sequencenum }}{{ $t('期') }}</div>
                 <div class="time">{{ formatDate(item.addtime, 'seconds') }}</div>
               </div>
               <div class="td">
                 <div class="num-box">
                   <div class="num blue-bg">{{ item.outcome_arr[0] }}</div>+
                   <div class="num blue-bg">{{ item.outcome_arr[1] }}</div>+
                   <div class="num blue-bg">{{ item.outcome_arr[2] }}</div>=
                   <div :class="['num', item.outcome_arr[3] >= 14 ? 'red-bg' : 'green-bg']">{{ item.outcome_arr[3] }}</div>
                 </div>
               </div>
               <div class="td">
                 {{ item.outcome_arr[3] >= 14 ? $t('大') : $t('小') }}/{{ item.outcome_arr[3] % 2 === 1 ? $t('单') : $t('双') }}
               </div>
               <div class="td">
                 {{ item.outcome_arr[3] >= 14 ? $t('大') : $t('小') }}{{ item.outcome_arr[3] % 2 === 1 ? $t('单') : $t('双') }}
               </div>

             </div>
           </div>
         </div>
         <div class="page-container">
           <transition name="slide-up">
             <ul v-if="isPageModal" class="page-popup-menu">
               <li @click="selectPageSize(item)" v-for="(item,index) in size_list" :key="index">{{ item }}</li>
             </ul>
           </transition>
           <div class="select-page-size" @click="isPageModal = !isPageModal">
             <div class="page-size">{{ $t('每页') }}{{page_size}}{{ $t('条') }}</div>
             <img src="/static/image/new/game/blue-arrow.png" :class="{'arrow': true, 'arrow-top': !isPageModal}" alt="">
           </div>
           <div class="page-box">
             <div class="page-btn" @click="page_first_init('history')">{{ $t('首页') }}</div>
             <div class="page-btn" @click="page_pre_init('history')">{{ $t('上一页') }}</div>
             <div class="line"></div>
             <div class="page-btn" @click="page_next_init('history')">{{ $t('下一页') }}</div>
             <div class="page-btn" @click="page_last_init('history')">{{ $t('尾页') }}</div>
           </div>
         </div>
       </div>
      </template>


    </div>
    <div class="overlay-bg" v-if="isPageModal" @click="isPageModal=false;"></div>
    <!--  编辑下注弹窗  -->
    <van-popup v-model="showEditBet" position="bottom" :round="true">
      <div class="game-type-container">
        <div class="game-type-main">
          <div class="game-type-nav">
            <div :class="{'nav-item': true, 'active': item.type === game_type_index}" v-for="(item,index) in game_type_nav" :key="index" @click="game_type_index = item.type">{{ $t(item.nameKey) }}</div>
          </div>
          <div class="game-type-content"  v-if="room_info.systemconfig">

            <div class="game-num-list" v-if="game_type_index === 1">

              <!--                   <div class="game-num-title">{{ $t('大小单双') }}</div>-->
              <div class="game-num-row">
                <div :class="{'game-num': true, 'active': game_type_val.includes('大') }" @click="selectGameType('大', room_info.systemconfig.dxds.odds_da)">
                  <div class="label">{{ $t('大') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.dxds.odds_da }}</div>{{ $t('倍') }}
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('小')}" @click="selectGameType('小', room_info.systemconfig.dxds.odds_xiao)">
                  <div class="label">{{ $t('小') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.dxds.odds_xiao }}</div>{{ $t('倍') }}
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('单')}" @click="selectGameType('单', room_info.systemconfig.dxds.odds_dan)">
                  <div class="label">{{ $t('单') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.dxds.odds_dan }}</div>{{ $t('倍') }}
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('双')}" @click="selectGameType('双', room_info.systemconfig.dxds.odds_shuang)">
                  <div class="label">{{ $t('双') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.dxds.odds_shuang }}</div>{{ $t('倍') }}
                </div>
              </div>
              <!--                   <div class="game-num-title">{{ $t('组合') }}</div>-->
              <div class="game-num-row">
                <div :class="{'game-num': true, 'active': game_type_val.includes('大单')}" @click="selectGameType('大单', room_info.systemconfig.combination.odds_dd_xs)">
                  <div class="label">{{ $t('大单') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.combination.odds_dd_xs }}</div>{{ $t('倍') }}
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('大双')}" @click="selectGameType('大双', room_info.systemconfig.combination.odds_xd_ds)">
                  <div class="label">{{ $t('大双') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.combination.odds_xd_ds }}</div>{{ $t('倍') }}
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('小单')}" @click="selectGameType('小单', room_info.systemconfig.combination.odds_xd_ds)">
                  <div class="label">{{ $t('小单') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.combination.odds_xd_ds }}</div>{{ $t('倍') }}
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('小双')}" @click="selectGameType('小双', room_info.systemconfig.combination.odds_dd_xs)">
                  <div class="label">{{ $t('小双') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.combination.odds_dd_xs }}</div>{{ $t('倍') }}
                </div>
              </div>
              <!--                   <div class="game-num-title">{{ $t('极大小') }}</div>-->
              <div class="game-num-row">
                <div :class="{'game-num': true, 'active': game_type_val.includes('极大')}" @click="selectGameType('极大', room_info.systemconfig.jidajixiao.odds)">
                  <div class="label">{{ $t('极大') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.jidajixiao.odds }}</div>{{ $t('倍') }}
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('极小')}" @click="selectGameType('极小', room_info.systemconfig.jidajixiao.odds)">
                  <div class="label">{{ $t('极小') }}</div>
                  <div class="unit">x</div>
                  <div class="value">{{ room_info.systemconfig.jidajixiao.odds }}</div>{{ $t('倍') }}
                </div>
              </div>
            </div>
            <div class="game-num-list" v-else-if="game_type_index === 2">
              <div class="game-num-title">{{ $t('形态') }}</div>
              <div class="game-num-row">
                <div :class="{'game-num': true, 'active': game_type_val.includes('豹子')}" @click="selectGameType('豹子', room_info.systemconfig.duizi_shunzi_baozi.odds_baozi)">
                  <div class="label">{{ $t('豹子') }}</div>
                  <div class="value">{{ room_info.systemconfig.duizi_shunzi_baozi.odds_baozi }}</div>
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('对子')}" @click="selectGameType('对子', room_info.systemconfig.duizi_shunzi_baozi.odds_duizi)">
                  <div class="label">{{ $t('对子') }}</div>
                  <div class="value">{{ room_info.systemconfig.duizi_shunzi_baozi.odds_duizi }}</div>
                </div>
                <div :class="{'game-num': true, 'active': game_type_val.includes('顺子')}" @click="selectGameType('顺子', room_info.systemconfig.duizi_shunzi_baozi.odds_shunzi)">
                  <div class="label">{{ $t('顺子') }}</div>
                  <div class="value">{{ room_info.systemconfig.duizi_shunzi_baozi.odds_shunzi }}</div>
                </div>

              </div>
            </div>
            <div class="game-num-list" v-else-if="game_type_index === 3">
              <!--                   <div class="game-num-title">{{ $t('特码') }}</div>-->
              <div class="game-num-row">
                <template  v-for="(_, i) in 28">
                  <div :class="{'game-num': true, 'active': game_type_val.includes(''+ i )}" @click="selectGameType('' + i, room_info.systemconfig.number['odds_'+i])">
                    <div class="label">{{ i }}</div>
                    <div class="unit">x</div>
                    <div class="value">{{ room_info.systemconfig.number['odds_'+i] }}</div>{{ $t('倍') }}
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
        <div class="game-type-btn">
          <div class="input-label">{{ $t('投注积分') }}:</div>
          <div class="input-box">
            <input type="text" :placeholder="$t('请输入投注积分')" v-model="num_val" @input="formatSendNum">
          </div>
          <div class="submit-btn btn" @click="sendBetMsg()">
            <div>{{ $t('投注') }}</div>
          </div>
        </div>

      </div>
    </van-popup>
    <!--  咪牌  -->
    <template v-if="brand_status && totalSeconds === 0">
      <div class="overlay-bg-white" @click="brand_status=false;"></div>
      <div class="scratch-box" >
        <div class="game-result-tips">{{ $t('第') }} {{ sequence_info.sequencenum }} {{ $t('期开奖结果') }}</div>
        <div class="eraser">
          <div class="scratch-card scratch" style="width: 100%; height: 100%;">
            <scratch-card
              ref="scratch"
              :brush-size="50"
              :cover-color="'#434444'"
            />
          </div>
          <b class="text blue-bg">{{ sequence_info.outcome_arr[0] }}</b> +
          <b class="text blue-bg">{{ sequence_info.outcome_arr[1] }}</b> +
          <b class="text blue-bg">{{ sequence_info.outcome_arr[2] }}</b> =
          <b :class="['text', sequence_info.outcome_arr[3] >= 14 ? 'red-bg' : 'green-bg']">{{ sequence_info.outcome_arr[3] }}</b>
          <span class="type">{{sequence_info.outcome_arr[3] >= 14 ? $t('大') : $t('小')}}, {{sequence_info.outcome_arr[3] % 2 === 1 ? $t('单') : $t('双')}}</span>
        </div>
        <div class="curren-num">{{ $t('当前第') }}{{ sequence_info.sequencenum }}</div>
        <div class="next-time">
          <span>{{ minute }}</span>{{ $t('分') }}<span>{{ second }}</span>{{ $t('秒') }}
        </div>
        <div class="time-title">{{ $t('距离开奖') }}</div>

        <div class="btn finish-btn" @click="getSequenceNum()">{{ $t('刷新') }}</div>
        <div class="btn back-btn" @click="brand_status = false">{{ $t('返回') }}</div>

      </div>
    </template>


  </div>
</template>

<script>
import { formatDate, translateText } from "../../common/utils"
import ScratchCard from '@/components/ScratchCard.vue';

export default {
  name: 'GameRoom',
  data() {
    return {
      mode: 1,   //1-专业模式   2-群投模式
      game_video: "jld28",
      title: '',
      page_size: 20,
      size_list: [20, 50, 100, 200],
      game_list: [],
      nav_type: 1,
      nav_list: [
        {id: 1, name: this.$t('投注区'), path: '', isShow: true},
        {id: 2, name: this.$t('路单区'), path: '/game-trend', isShow: true},
        {id: 3, name: this.$t('游戏记录'), path: '', isShow: true},
        {id: 4, name: this.$t('玩法介绍'), path: '', isShow: true},
        // {id: 5, name: this.$t('开奖验证'), path: '/game-scratch', isShow: true},
        // {id: 5, name: this.$t('开奖验证'), path: '', isShow: true},
        {id: 6, name: this.$t('开奖记录'), path: '', isShow: true},
        {id: 7, name: this.$t('统计'), path: '/game-statis', isShow: true},
      ],

      brand_status: false,   // 咪牌状态
      isDropList: false,

      game_type_val: [],
      game_odds_val: [],
      game_type_price: [],
      game_type_index: 1,
      game_type_nav: [
        {
          type: 1,
          nameKey: '双面玩法'
        },
        // {
        //   type: 2,
        //   name: this.$t('形态')
        // },
        {
          type: 3,
          nameKey: '特码玩法'
        }
      ],
      totalSeconds: 180, // 倒計時總秒數 (例如 3分鐘)
      hours: '00',
      minute: '00',
      second: '00',
      timer: null,
      time_interval: null,


      // 分页条数弹窗
      isPageModal: false,
      room: 'one',
      money: '0.00',    // 余额
      room_info: {
        youxi: {}
      },
      chat_list: [],
      sequence_info: {},

      trend_page: 1,
      trend_total_page: 1,
      trend_list: [],
      send_val: '',

      history_page: 1,
      history_total_page: 1,
      history_list: [],

      bet_page: 1,
      bet_total_page: 1,
      bet_list: [],
      bet_info: {},

      showEditBet: false,
      timerInter: null,
      loadingMsg: false,

      num_val: '',
      statusInterval: null,

      endTime: 0,       // 结束时间戳

    }
  },
  components: { ScratchCard },
  computed: {
    profit_money() {
      // 预计盈利 =  投注额*赔率

      let num = 0;

      if(Number(this.num_val) > 0) {
        this.game_odds_val.forEach(item => {
          num += Number(this.num_val) * Number(item)
        })
      }else {
        console.log(this.game_type_price)
        console.log(this.game_odds_val)
        this.game_type_price.forEach(price => {
          this.game_odds_val.forEach(item => {
            num += Number(price) * Number(item)
          })
        })
      }

      return this.formatNumber(num)
    },
    getTotalMoney() {
      let price = 0;
      if(Number(this.num_val) > 0) {
        price = this.game_type_val.length * Number(this.num_val)
      }else {
        this.game_type_price.forEach((item) => {
          price+= this.game_type_val.length * Number(item)
        })
      }
      return this.formatNumber(price)
    }
  },
  mounted() {
    const query = this.$route.query;
    if(query.room) {
      this.room = query.room;
    }
    if(query.game_video) {
      this.game_video = query.game_video;
    }

    if(localStorage.getItem('brand_status')) {
      this.brand_status = JSON.parse(localStorage.getItem('brand_status'));
    }
    this.init()

    document.addEventListener('visibilitychange', this.handleVisibility)

  },
  methods: {
    formatDate,
    init() {
      this.getRoomInfo()
      this.getMoneyInfo()
      this.getSequenceNum()
      this.getGameList()
      this.clickNaTab(this.nav_type, '')
    },
    back() {
      window.history.go(-1)
    },
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    clickNaTab(type, path) {
      if (path.length > 0) {
        const route = {path: path}
        if(path === '/game-statis' || path === '/game-trend') {
          route.query = {
            game_video: this.game_video
          }
        }
        this.$router.push(route)
        return;
      }
      this.nav_type = type
      if(type === 3) {
        // 游戏记录
        this.getBetJson()
      }else if(type === 6) {
        // 开奖历史
        this.page_first_init('history');
      }
    },
    selectPageSize(size, type = 'trend') {
      this.page_size = size
      this.isPageModal = false
      this.page_first_init(type)
    },
    // 默认全部余额转入
    submitConfirmModal() {
      if(this.$store.state.userInfo.transferstatus === 1) {
      this.$apiFun.post('/api/transfer', {
        amount: "100",
        sourcetype: "userbalance",
        targettype: "pc28",
        all: 1
      }).then(async (res) => {
        if (res.code === 200) {
        }else {
          // this.showTost(0, res.message);
        }
      }) .catch(res => {
      });
      }
    },
    getRoomInfo() {
      this.$apiFun
        .post('/api/game/index', {
          video: this.game_video,
          room: this.room
        })
        .then(async (res) => {
          if (res.code !== 200) {
            // this.showTost(0, res.data.message);
            if(res.data.message) {
              this.ErrorMsg(res.data.message)
            }
          }
          if (res.code === 200) {
            this.room_info = res.data
            const text_arr = []
            this.room_info.chat_info.forEach((item) => {
              text_arr.push(item.content)
            })
            const translate_arr = await translateText(text_arr)
            translate_arr.forEach((item, index) => {
              this.room_info.chat_info[index].content = item
            })
            this.chat_list = this.room_info.chat_info
            const val = await translateText([this.room_info.youxi.name])
            this.title = val[0]
            this.setIntervalStatus()
            this.getGameIntroduce()
          }
          this.getMsg()
          clearInterval(this.timerInter)
          this.timerInter = setInterval(() => {
            if (!this.loadingMsg) this.getMsg();
          }, 1500);
        })
        .catch(res => {
        });
    },
    // 获取所有游戏列表
    getGameList() {
      this.$apiFun
        .post('/api/game/youxiList', {
          type: this.game_video,
          page: 1,
          per_page: 100
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = Object.values(res.data)
            const text_arr = []
            list.forEach((item) => {
              text_arr.push(item.name)
            })
            const translate_arr = await translateText(text_arr)
            translate_arr.forEach((item, index) => {
              list[index].name = item
            })
            this.game_list = list

          }
        })
        .catch(res => {
        });
    },
    // 更新用户状态
    updateOnlineStatus() {
      this.$apiFun
        .post('/api/game/updateOnlineStatus', {
          location: this.title+'-'+(this.room === 'one' ? '初级房' : '中级房'),
        })
        .then(async (res) => {
          // if (res.code !== 200) {
            // this.showTost(0, res.data.message);
          // }
          // if (res.code === 200) {
          // }
        })
        .catch(res => {
        });
    },
    setIntervalStatus() {
      clearInterval(this.statusInterval)
      this.statusInterval = setInterval(()=> {
        this.updateOnlineStatus()
      }, 3000)
    },
    // 显示、隐藏游戏列表
    toggleGameList(state) {
      if(state) {
        this.getGameList()
        this.isPageModal = true
      }else {
        this.isPageModal = false
      }
    },
    selectGameList(item) {
      this.isPageModal = false
      if(item.type === 'jld28' || item.type === 'jld28_5') {
        this.game_video = item.type
        this.room = item.room
        const query = {
          game_video: item.type,
          room: item.room
        }
        const currentQuery = this.$route && this.$route.query ? this.$route.query : {}
        if(currentQuery.game_video !== query.game_video || currentQuery.room !== query.room) {
          this.$router.replace({
            path: '/game-room',
            query
          })
        }
        this.init()
      }else {
        // 跳转六合
        this.$router.push({
          path: '/game-Liuhe-room',
          query: {
            room: item.room,
            game_video: item.type
          }
        });

      }
    },
    // 余额不足不能进入房间
    async ErrorMsg(msg) {
      const message = await translateText([msg]);
      let that = this;
      that.$dialog
        .alert({
          title: that.$t('错误提示'),
          message: message[0],
        })
        .then(() => {
          this.back()
        })
    },
    getSequenceNum() {
      this.$nextTick(() => {
        this.resetScratch()
      })
      this.$apiFun
        .post('/api/game/ajaxSequencenum', {
          video_both: this.game_video,
          sequencenum_span: ''
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            if(res.data && Object.keys(res.data).length > 0) {
              this.stopTimer()
              const info =  res.data
              info.outcome_arr = info.outcome.split('-')

              this.sequence_info = info


              const starttime = parseInt(info.sealing_plate)
              const fwq_time = parseInt(info.fwq_time)

              var elapsed = Math.floor((Date.now() -  Date.now()) / 1000);
              const nowtime = fwq_time + elapsed;

              // 剩余秒数
              const time = starttime - nowtime;
              this.totalSeconds = time
              this.startCountdown()
            }else {
              setTimeout(() => {
                this.getSequenceNum()
              }, 3000);
            }

          }
        })
        .catch(res => {
        });
    },
    // 重置刮刮乐
    resetScratch() {
      if(this.$refs.scratch) {
        this.$refs.scratch.reset();
      }
    },
    //页码 - 首页
    page_first_init( type) {
      if(type === 'trend') {
       this.trend_page = 1
       this.getTrendList()
      }else if(type === 'history') {
        this.history_page = 1;
        this.getHistoryList()
      }else if(type === 'bet') {
        this.bet_page = 1
        this.getBetJson()
      }
    },
    //页码 - 上一页
    page_pre_init( type) {
      if(type === 'trend') {
        this.trend_page--;
        this.getTrendList()
      }else if(type === 'history') {
        this.history_page--;
        this.getHistoryList()
      }else if(type === 'bet') {
        this.bet_page--;
        this.getBetJson()
      }
    },
    //页码 - 下一页
    page_next_init( type) {
      if(type === 'trend') {
        this.trend_page++;
        this.getTrendList()
      }else if(type === 'history') {
        this.history_page++;
        this.getHistoryList()
      }else if(type === 'bet') {
        this.bet_page++;
        this.getBetJson()
      }
    },
    //页码 - 尾页
    page_last_init( type) {
      if(type === 'trend') {
        this.trend_page = this.trend_total_page;
        this.getTrendList()
      }else if(type === 'history') {
        this.history_page = this.history_total_page
        this.getHistoryList()
      }else if(type === 'bet') {
        this.bet_page = this.bet_total_page
        this.getBetJson()
      }
    },
    async getMsg() {
      if (this.loadingMsg) return; // 防止并发请求
      this.loadingMsg = true;

      try {
        const res = await this.$apiFun.post('/api/game/ajaxchat', {
          video_both: this.game_video,
          room: this.room,
          lastId: this.room_info.lastId
        });

        if (res.code !== 200) {
          this.showTost(0, res.data.message);
          return;
        }

        const list = res.data.list || [];
        if (list.length === 0) {
          this.loadingMsg = false;
          return;
        }
        // 翻译内容
        const text_arr = list.map(i => i.content || '');
        const translate_arr = await translateText(text_arr);

        list.forEach((item, index) => {
          if (translate_arr[index]) item.content = translate_arr[index];
        });
        this.room_info.lastId = list[list.length - 1].id;
        // 合并并滚动
        this.chat_list = this.mergeArrayWithoutDup(this.chat_list, list);
        this.scrollMsgBox();

      } catch (err) {
        console.error('getMsg error:', err);
      } finally {
        this.loadingMsg = false;
      }
    },
    // 开奖结果
    getTrendList() {

      if(this.trend_page > this.trend_total_page) {
        this.showTost(0, this.$t('已经是最后一页啦！'));
        return;
      }
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/trend', {
          type: this.game_video,
          room: this.room,
          per_page: this.page_size,
          page: this.trend_page
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = res.data.list
            this.trend_total_page = res.data.total_pages > 0 ? res.data.total_pages : 1;
            list.forEach(item => {
              item.outcome_arr = item.outcome.split('-')
            })
            this.trend_list = list
          }
          this.$parent.hideLoading();
        })
        .catch(res => {
          this.$parent.hideLoading();
        });
    },
    // 开奖记录
    getHistoryList() {
      if(this.history_page > this.history_total_page) {
        this.showTost(0, this.$t('已经是最后一页啦！'));
        return;
      }
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/trend', {
          type: this.game_video,
          room: this.room,
          per_page: this.page_size,
          page: this.history_page
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = res.data.list
            this.history_total_page = res.data.total_pages > 0 ? res.data.total_pages : 1;
            list.forEach(item => {
              item.outcome_arr = item.outcome.split('-')
            })
            this.history_list = list
          }
          this.$parent.hideLoading();
        })
        .catch(res => {
          this.$parent.hideLoading();
        });
    },
    // 游戏记录
    getBetJson() {
      if(this.bet_page > this.bet_total_page) {
        this.showTost(0, this.$t('已经是最后一页啦！'));
        return;
      }
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/betsJson', {
          type: this.game_video,
          room: this.room,
          per_page: this.page_size,
          page: this.bet_page
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            this.bet_info = res.data
            const list = res.data.list
            this.bet_total_page = res.data.total_pages > 0 ? res.data.total_pages : 1;
            list.forEach(item => {
              item.outcome_arr = item.outcome.split('-')
            })
            this.bet_list = list
          }
          this.$parent.hideLoading();
        })
        .catch(res => {
          this.$parent.hideLoading();
        });
    },

    sendMessage() {

      if(this.send_val.length === 0) {
        this.showTost(0, this.$t('发送的消息不能为空'));
        return;
      }
      // if (this.isWithinTimeRange('19:56:30', '20:29:30')) {
      //   // 显示提示内容
      //   // this.showTost(0, `18:56～19:30 为维护时间`);
      //   this.showTost(0, this.$t('19:56:30～20:29:30 为维护时间'));
      //   return;
      // }
      // if (this.isWithinTimeRange('23:55:30', '00:05:00')) {
      //   // 显示提示内容
      //   this.showTost(0, this.$t('23:55:30～00:05:00 为维护时间'));
      //   return;
      // }
      if(this.totalSeconds <= Number(this.room_info.youxi.qs_start_time)) {
        this.showTost(0, this.$t('本期已封盘'));
        return;
      }
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/game/chooseChat', {
          video_both: this.game_video,
          room: this.room,
          data: this.send_val,
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            this.showTost(1, this.$t('发送成功'));
            this.clearSendInput()
            this.getMoneyInfo()
            this.toggleMode(false)
            setTimeout(() => {
              this.scrollMsgBox()
            }, 1000)
          }
          this.$parent.hideLoading()
        })
        .catch(res => {
          this.$parent.hideLoading()
        });
    },
    clearSendInput() {
      this.send_val = ''
      this.game_type_val = []
      this.game_odds_val = []
      this.game_type_price = []
      this.num_val = ''
    },
    formatSendNum(event) {
      let value = this.num_val
      value = value.replace(/[^\d.]/g, '')
      value = value.replace(/\.{2,}/g, '.')
      value = value.replace('.', '#').replace(/\./g, '').replace('#', '.')
      value = value.replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2')
      this.num_val = value
      this.game_type_price = []
    },
    sendBetMsg(){
      if(this.game_type_val.length === 0) {
        this.showTost(0, this.$t('请选择玩法'));
        return false;
      }
      let type_price = 0;
      this.game_type_price.forEach(item => {
        type_price+= Number(item)
      })
      const price = Number(this.num_val) > 0 ? Number(this.num_val) : type_price
      if(price <= 0) {
        this.showTost(0, this.$t('请输入金额'));
        return false;
      }
      let val = ''
      this.game_type_val.forEach((item, index) => {
        val += (index > 0 ? ' ' : '') + item + (this.isNumber(item) ? '.' : '') + price
      })

      this.send_val = val

      this.sendMessage()
    },
    // 合并两个数组并去重
    mergeArrayWithoutDup(arr1, arr2) {
      return arr1.concat(arr2.filter(item2 => !arr1.some(item1 => item1.id === item2.id)));
    },
    // 获取当前越南时间（UTC+7）
    getVietnamTime() {
      const now = new Date();
      // 将当前时间转换为 UTC 毫秒
      // const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      // 再加上 7 小时偏移（越南时间）
      // return new Date(utc + 7 * 60 * 60 * 1000);
      return now;
    },
    isInVietnamMaintenanceTime() {
      const vnTime = this.getVietnamTime();
      const hours = vnTime.getHours();
      const minutes = vnTime.getMinutes();

      // 只在 18 点 56 分到 19 点 30 分之间为 true
      if (hours === 18 && minutes >= 56) return true;
      if (hours === 19 && minutes < 30) return true;

      return false;
    },
    isWithinTimeRange(startTime, endTime) {
      // 获取当前时间
      const now = new Date();

      // 获取当前的小时、分钟和秒
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentSecond = now.getSeconds();

      // 将当前时间转换为字符串格式 "HH:MM:SS"
      const currentFormattedTime = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}:${currentSecond.toString().padStart(2, '0')}`;

      // 将开始和结束时间也转换为字符串格式 "HH:MM:SS"
      const formattedStartTime = startTime.replace(/:/g, ''); // 移除冒号以方便比较
      const formattedEndTime = endTime.replace(/:/g, ''); // 移除冒号以方便比较
      const formattedCurrentTime = currentFormattedTime.replace(/:/g, ''); // 移除冒号以方便比较

      // 比较当前时间是否在开始时间和结束时间之间
      return formattedCurrentTime >= formattedStartTime && formattedCurrentTime <= formattedEndTime;
    },

    // 判断是否为数字
    isNumber(value) {
      return !isNaN(Number(value)) && value !== '';
    },
    // 获取越南当前时间
    getVietnamNow() {
      const now = new Date();
      const utc = now.getTime() + now.getTimezoneOffset() * 60000; // 当前时间转为 UTC
      const vietnamTime = new Date(utc + 7 * 60 * 60000); // UTC + 7小时
      return vietnamTime;
    },
    getMoneyInfo() {
      this.$apiFun
        .get('/api/game/chooseUser', {
          video: this.game_video,
          room: this.room
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            this.money = res.data.balance
          }
        })
        .catch(res => {
        });
    },

    // startCountdown() {
    //   this.updateDisplay() // 立即顯示初始時間
    //   clearInterval(this.timer)
    //   this.timer = setInterval(() => {
    //     if (this.totalSeconds > 0) {
    //       this.totalSeconds--
    //       const h = Math.floor(this.totalSeconds / 3600)
    //       const m = Math.floor((this.totalSeconds % 3600) / 60)
    //       const s = this.totalSeconds % 60
    //
    //       this.hours = String(h).padStart(2, '0')
    //       this.minute = String(m).padStart(2, '0')
    //       this.second = String(s).padStart(2, '0')
    //     } else {
    //       clearInterval(this.timer)
    //       this.timer = null
    //       this.startTimer()
    //
    //     }
    //   }, 1000)
    // },
    handleVisibility() {
      if (!document.hidden) {
        this.updateDisplay() // 页面恢复立即刷新
      }
    },
    startCountdown() {
      clearInterval(this.timer)

      // ⭐ 设置结束时间（核心）
      this.endTime = Date.now() + this.totalSeconds * 1000

      this.updateDisplay() // 立即更新一次

      this.timer = setInterval(() => {
        this.updateDisplay()
      }, 1000)
    },

    updateDisplay() {
      const remainSeconds = Math.floor((this.endTime - Date.now()) / 1000)

      if (remainSeconds > 0) {
        const h = Math.floor(remainSeconds / 3600)
        const m = Math.floor((remainSeconds % 3600) / 60)
        const s = remainSeconds % 60

        this.hours = String(h).padStart(2, '0')
        this.minute = String(m).padStart(2, '0')
        this.second = String(s).padStart(2, '0')
      } else {
        this.hours = '00'
        this.minute = '00'
        this.second = '00'

        clearInterval(this.timer)
        this.timer = null

        this.startTimer() // 你原来的结束逻辑
      }
    },
    startTimer() {
      if (this.time_interval) {
        clearInterval(this.time_interval)
      }
      this.time_interval = setInterval(() => {
        this.getSequenceNum()
      }, 6000)
    },
    stopTimer() {
      if (this.time_interval) {
        clearInterval(this.time_interval)
        this.time_interval = null
      }
    },
    toggleMode(state) {
      this.showEditBet = state
    },
    toggleArrowMore() {
      this.isDropList = !this.isDropList;
      if(this.isDropList) {
        this.trend_page = 1
        this.getTrendList()
      }
    },
    selectGameType(type, odds) {
      this.game_type_val = [type]
      this.game_odds_val = [odds]
    },
    toggleBrand() {
      this.brand_status = !this.brand_status;
      localStorage.setItem("brand_status", JSON.stringify(this.brand_status))
    },
    scrollMsgBox() {
      this.$nextTick(() => {
        // 👇 滚动到底部
        const el = this.$refs.scrollContainer;
        if(el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    formatNumber(num) {
      if (num == null || num === '') return num;

      const str = num.toString();
      if (!str.includes('.')) return str;

      const [int, decimal] = str.split('.');
      if (decimal.length <= 2) return str;

      return `${int}.${decimal.slice(0, 2)}`;
    },
    getGameIntroduce() {
      let game_wf = ''
      switch (this.room) {
        case 'one':
          game_wf = this.room_info.youxi.game_wf
          break;
        case 'two':
          game_wf = this.room_info.youxi.two_game_wf
          break;
        case 'three':
          game_wf = this.room_info.youxi.three_game_wf
          break;
      }
      return game_wf || '';
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timerInter)
    clearInterval(this.statusInterval)
    this.stopTimer();
    document.removeEventListener('visibilitychange', this.handleVisibility)
  },
  deactivated() {
    clearInterval(this.timer)
    clearInterval(this.timerInter)
    clearInterval(this.statusInterval)
    this.stopTimer();
  }
}
</script>

<style scoped lang="scss">
.game-room-page {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  max-width: 10rem;
  width: 100%;
  margin: auto;
  z-index: 1;
  overflow: hidden;
  bottom: 0;
  bottom: env(safe-area-inset-bottom, 0); /* 兼容刘海/手势栏 */
  background-color: #000000;
  background-image: url("/static/image/new/game/game-room-bg.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  box-sizing: border-box;
  font-family: PingFang SC;

  .green-bg {
    color: #fff !important;
    background: linear-gradient( 180deg, #00E137 0%, #00C400 47%, #00DC00 100%) !important;
  }
  .red-bg {
    color: #fff !important;
    background: linear-gradient( 180deg, #FF5861 0%, #EC2627 47%, #FB3E38 100%) !important;
  }
  .blue-bg {
    color: #fff !important;
    background: linear-gradient( 180deg, #99CFFF 0%, #7D9BFD 47%, #388BF6 100%) !important;
  }
  .red-color {
    color: #EF2B29 !important;
  }
  .blue-color {
    color: #4B90F8 !important;
  }
  .head-area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .3rem;

    .leftImg {
      width: .5rem;
      text-align: right;
      transform: rotate(180deg);
      margin-bottom: .1rem;
    }

    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }

    .head_text {
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 0.43rem;
      color: #fff;
      flex: 1;
      text-align: left;
      display: flex;
      align-items: center;
      overflow: hidden;

      .title {
        max-width: 50%;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .status {
        background: #007AFF;
        border-radius: .11rem;
        height: .67rem;
        line-height: .67rem;
        padding: 0 0.16rem;
        font-size: 0.32rem;
        margin-left: .2rem;
        display: flex;
        align-items: center;
        .arrow {
          width: .25rem;
          margin-left: .11rem;
         &.open {
           transform: rotate(-180deg);
         }
        }
      }
    }

    .right_menu {
      font-size: 0.29rem;
      font-family: PingFang SC;
      color: #fff;
      flex-shrink: 0;
      text-align: right;
      display: flex;
      align-items: center;

      .money {
        color: #007AFF;
        font-size: 0.34rem;
      }
    }
  }

  .lottery-box-bg {
    background: linear-gradient(to right, #000744, #666666);
    border-radius: .24rem;
    padding: .02rem;
    margin: 0.2rem .4rem 0;
    position: relative;

  }
  .select-game-list {
    position: absolute;
    left: .2rem;
    top: 0;
    background: #fff;
    max-width: 80%;
    text-align: center;
    border-radius: .2rem;
    color: #333;
    font-size: .34rem;
    z-index: 9;
    overflow: hidden;
    li {
      height: 1.2rem;
      line-height: 1.2rem;
      padding: 0 .15rem;
      &.active {
        background: #0A7BFC;
        color: #fff;
      }
    }
  }
  .lottery-box {
    background: linear-gradient(to right, #1c2323, #1b2021);
    border-radius: .24rem;
    overflow: hidden;
    position: relative;
    padding: .32rem;

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.32rem;
      //padding-left: .2rem;
      text-align: center;

      .top-left {
        flex-shrink: 0;
        .lottery-period {
        }

        .text {
          color: #929697;
          margin-top: 0.04rem;
        }
      }

      .top-right {
        display: flex;
        align-items: center;

        .lottery-num {
          font-size: .37rem;
          margin-right: .21rem;
        }

        .brand-status {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          height: 0.53rem;
          line-height: 0.53rem;
          background: #007AFF;
          border-radius: .27rem;
          padding: 0 .11rem;
          font-size: 0.24rem;

          .icon {
            width: 0.37rem;
            margin-right: .13rem;
          }
        }
      }
    }

    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.21rem;

      .count-down {
        display: flex;
        align-items: center;

        .hours-box, .minute-box, .second-box {
          width: 0.8rem;
          height: 1.01rem;
          margin-right: 0.21rem;
          background-size: 100% 100%;
          font-family: Gilroy, Gilroy;
          font-size: 0.43rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hours-box {
          background-image: url("/static/image/new/game/minute-bg.png");
        }

        .minute-box {
          background-image: url("/static/image/new/game/minute-bg.png");
        }

        .second-box {
          background-image: url("/static/image/new/game/second-bg.png");
        }

      }

      .lottery-results {
        display: flex;
        align-items: center;
        margin-left: 0.43rem;

        .num {
          flex-shrink: 0;
          width: .8rem;
          height: .8rem;
          line-height: .8rem;
          text-align: center;
          font-size: 0.43rem;
          border-radius: 50%;
          margin: 0 .1rem;
        }

        .symbol {

        }
      }

      .arrow-more {
        width: 0.29rem;
        margin-left: 0.27rem;
        &.rotate-arrow {
          transform: rotate(180deg);
        }
      }
    }
  }

  .nav-list {
    display: flex;
    align-items: center;
    overflow-x: auto;
    margin: 0 .4rem;
    padding: .21rem 0;

    .nav-item {
      height: 0.69rem;
      line-height: 0.69rem;
      background: #1E2223;
      border: 0.01rem solid;
      border-image: linear-gradient(to right, #333333, #666666);
      padding: 0 .16rem;
      margin-right: .16rem;
      flex-shrink: 0;
      border-radius: .45rem;
      font-size: 0.32rem;

      &.active {
        background: linear-gradient(to right, #007AFF, #007AFF);
      }

    }
  }

  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    .msg-container {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      position: relative;
      .msg-list {
        padding: .53rem .4rem;
        flex: 1;
        overflow: auto;
        .msg-item {
          display: flex;
          align-items: self-start;
          margin-bottom: .53rem;
          .left {
            .avatar {
              width: 0.91rem;
              height: 0.91rem;
              border-radius: 50%;
              overflow: hidden;
            }
          }

          .right {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 0 .21rem;
            box-sizing: border-box;
            .msg-name {
              font-size: .37rem;
              margin-bottom: .2rem;
              color: #3997FF;
              display: flex;
              align-items: center;
            }
            .vip-box {
              background: #84E5FE;
              font-size: .25rem;
              display: flex;
              align-items: center;
              margin: 0 .2rem;
              border-radius: .2rem;
              padding-right: .15rem;
              color: #000;
              font-weight: bold;
              .vip-icon {
                width: 0.4rem;
                margin-left: 0rem;
                margin-right: .1rem;
              }
            }
            .msg-content {
              max-width: 100%;
              background: #1F2425;
              padding: 0.27rem .3rem;
              border-radius: .16rem;
              font-size: 0.32rem;

              .msg-time {
                margin-bottom: .27rem;
                font-family: PingFang SC;
              }
              .msg-text {
                margin-bottom: .1rem;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }

          &.self-msg-item {
            flex-direction: row-reverse;
            text-align: left;
            .right {
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
            }
            .msg-name {
              flex-direction: row-reverse;
            }
          }
        }
      }
    }

    .record-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .record-list {
        padding: 0.2rem .4rem;
        flex: 1;
        overflow: auto;
        .record-item {
          border-radius: .27rem;
          overflow: hidden;
          font-size: 0.32rem;
          margin-bottom: .27rem;
          .record-head {
            background: linear-gradient( 91deg, #007AFF 0%, #50A4FF 100%);
            height: .99rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .27rem;
            .right {
              display: flex;
              align-items: center;
              .num-box {
                display: flex;
                align-items: center;
                .num {
                  width: .56rem;
                  height: .56rem;
                  background: #fff;
                  border: 0.02rem solid #50A4FF;
                  font-size: 0.32rem;
                  color: #007AFF;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50%;
                  margin: 0 .05rem;
                }
                .num2 {
                  color: #fff;
                }
              }
            }
          }
          .record-content {
            background: #1f2425;
            display: flex;
            flex-wrap: wrap;
            padding: 0 .27rem .21rem;
            .record-text {
              width: 67%;
              margin-top: .21rem;
              display: flex;
              align-items: center;
              font-size: 0.27rem;
              &:nth-child(even) {
                width: 33%;
              }
              .label {
                color: #8F9394;
              }

            }
          }
        }
      }
      .record-footer {
        padding: .53rem .4rem .75rem;
        .total-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: .45rem;
          .info-item {
            font-size: 0.32rem;
            color: #B8B8B8;
            padding: 0 .2rem;
            text-align: center;
            .value {
              font-family: Gilroy, Gilroy;
              font-size: 0.43rem;
              color: #5FACFF;
              margin-bottom: .29rem;
              text-align: center;
            }
          }
        }
        .page-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 1.07rem;
          background: #1E2223;
          border-radius: 0.63rem 0.63rem 0.63rem 0.63rem;
          border: 0.01rem solid #6A6A6A;
          padding: 0 .48rem;
          font-size: 0.32rem;
          .line {
            width: .01rem;
            height: 0.49rem;
            background: #6A6A6A;
          }
        }
      }
    }
    .game-introduce {
      padding: .2rem .3rem;
      white-space: pre-line;
      p {
        font-size: .32rem;
        color: #b8b8b8;
      }
      .title {
        font-size: .4rem;
        font-weight: bold;
        margin-top: .5rem;
        margin-bottom: .2rem;
        color: #5facff;
      }
      .category {
        color: #fff;
        margin: .3rem 0;
      }
    }
    .lottery-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .big-title {
        font-size: 0.37rem;
        height: 1.2rem;
        display: flex;
        align-items: center;
        padding: 0 .4rem;
      }

      .table-head {
        height: 0.88rem;
        background: #1E2223;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .2rem;
        font-size: 0.32rem;
        color: #8F9394;
        text-align: center;
        .td {
          width: 15%;
          &:first-child {
            width: 30%;
          }
          &:nth-child(2) {
            width: 20%;
          }
          &:nth-child(3) {
            width: 20%;
          }
        }
      }

      .recode-table {
        flex: 1;
        overflow: auto;

        .table-list {
          .tr {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .2rem;
            height: 1.2rem;
            text-align: center;
            .td {
              width: 15%;
              font-size: 0.27rem;
              &:first-child {
                width: 30%;
              }
              &:nth-child(2) {
                width: 40%;
              }
            }
            .sequenceNum {
              margin-bottom: .1rem;
              font-size: 0.27rem;
            }
            .time {
              font-size: 0.27rem;
            }
            .num-box {
              display: flex;
              align-items: center;
              justify-content: center;
              .num {
                flex-shrink: 0;
                width: .55rem;
                height: .55rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin: 0 .1rem;
              }
            }

          }
        }

      }
    }
    .list_drop_box {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      font-size: 0.32rem;
      .table-head {
        background: #1E2223;
        height: .88rem;
        display: flex;
        align-items: center;
        color: #8F9394;
        padding: 0 .2rem;
        .td {
          width: 30%;
          text-align: center;
        }
      }
      .recode-table {
        flex: 1;
        overflow: auto;
        .tr {
          display: flex;
          align-items: center;
          height: 1.1rem;
          padding: 0 .2rem;
          .td {
            width: 30%;
            text-align: center;
            &:nth-child(2) {
              width: 48%;
            }
            &:last-child {
              width: 20%;
            }
            .num-box {
              display: flex;
              align-items: center;
              justify-content: center;
              .num {
                width: .62rem;
                height: .62rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin: 0 .1rem;
              }
            }
            .sum-info {
              display: flex;
              align-items: center;
              justify-content: space-around;
              padding: 0 .2rem;
            }
            .sequenceNum {
              margin-bottom: .1rem;
              font-size: 0.27rem;
            }
            .time {
              font-size: 0.27rem;
            }
          }
        }
      }
    }
  }

  .page-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem .4rem;
    position: relative;
    z-index: 10;
    .select-page-size {
      width: 2.96rem;
      height: 1.07rem;
      background: #1E2223;
      border-radius: 0.63rem 0.63rem 0.63rem 0.63rem;
      border: 0.01rem solid #6A6A6A;
      margin-right: .27rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.32rem;
      text-align: center;
      padding: 0 .15rem;
      box-sizing: border-box;
      .page-size {
        max-width: 70%;
      }
      .arrow {
        width: 0.29rem;
        margin-left: .27rem;
      }

      .arrow-top {
        transform: rotate(180deg);
      }
    }
    .page-box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .32rem;
      height: 1.07rem;
      background: #1E2223;
      border-radius: 0.63rem 0.63rem 0.63rem 0.63rem;
      border: 0.01rem solid #6A6A6A;
      .line {
        width: .01rem;
        height: 0.49rem;
        background: #6A6A6A;
      }
      .page-btn {
        flex-shrink: 0;
        max-width: 20%;
        font-size: .32rem;
        text-align: center;
      }
    }
    .page-popup-menu {
      position: absolute;
      left: 0.4rem;
      bottom: 82%;
      background: #fff;
      width: 3rem;
      text-align: center;
      border-radius: .2rem;
      color: #333;
      font-size: .34rem;
      z-index: 9;
      li {
        height: 1.2rem;
        line-height: 1.2rem;
      }

    }
    .slide-up-enter-active,
    .slide-up-leave-active {
      transition: all 0.25s ease;
    }

    /* 出现时：从下往上浮现 */
    .slide-up-enter {
      opacity: 0;
      transform: translateY(10px);
    }

    /* 离开时：往下淡出 */
    .slide-up-leave-to {
      opacity: 0;
      transform: translateY(10px);
    }
  }

  .game-type-container {
    width: 100%;
    height: 100%;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: .53rem .41rem .32rem;
    box-sizing: border-box;
    background: #1C1C1E;
    .game-type-main {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .game-type-nav {
        background: #111113;
        border-radius: .15rem;
        padding: .15rem;
        display: flex;
        margin-bottom: .28rem;
        flex-shrink: 0;
        .nav-item {
          width: 50%;
          height: 1.02rem;
          line-height: 1.02rem;
          text-align: center;
          position: relative;
          font-size: 0.41rem;
          border-radius: .15rem;
          color: #999;
          &.active {
            background: #3E99FF;
            font-weight: bold;
            color: #fff;
          }

        }
      }
      .game-type-content {
        height: 100%;
        overflow: auto;
        flex: 1;
        .game-num-list {
          width: 100%;
          .game-num-title {
            font-size: 0.32rem;
            margin-bottom: .27rem;
          }
          .game-num-row {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            .game-num {
              width: 2.15rem;
              height: 1.28rem;
              background: #242426;
              flex-shrink: 0;
              margin-right: .15rem;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: .15rem;
              font-size: 0.3rem;
              border: 1px solid #FFFFFF1A;
              border-radius: .2rem;
              padding: 0 .1rem;
              &:nth-child(4n+4) {
                margin-right: 0;
              }
              .label {
                text-align: center;
              }
              .value {
                color: #3E99FF;
                font-family: Gilroy;
                font-weight: 900;
              }
              .unit {
                font-size: .25rem;
                margin: 0 .08rem;
              }
              &.active {
                background: linear-gradient(to right, #2C6EF6, #6094FF 100%);
                color: #fff;
                .value {
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
    .game-type-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: .28rem 0rem 0;
      position: relative;
      .input-label {
        color: #999999;
        font-size: .35rem;
        margin-right: .2rem;
      }
      .input-box {
        height: .92rem;
        flex: 1;
        background: #111113;
        border-radius: .15rem;
        padding: 0 .25rem;
        input {
          width: 100%;
          height: 100%;
          outline: none;
          border: none;
          background: transparent !important;
          font-size: .3rem;
        }
      }
      .btn {
        height: 0.92rem;
        background: #3E99FF;
        margin-left: .2rem;
        border-radius: .15rem;
      }
      .submit-btn {
        padding: 0 .6rem;
        font-size: 0.35rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }
    }
  }

  .footer {
    background: #1F2425;
    padding: .43rem .4rem;

    .bet-box {
      display: flex;
      align-items: center;
      font-family: PingFang SC, PingFang SC;

      .select-btn {
        width: .8rem;
        min-width: .8rem;
        height: .8rem;
        padding: 0;
        background: #2C6EF6;
        border-radius: .4rem;
        color: #F1F1F1;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: .2rem;
        cursor: pointer;
      }

      .select-icon {
        width: .42rem;
        height: .42rem;
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-width: 2;
      }

      .bet-input {
        flex: 1;
        height: .8rem;
        background: #000000;
        border-radius: .11rem;
        padding: 0 .27rem;
        input {
          width: 100%;
          height: 100%;
          outline: none;
          border: none;
          background: none;
        }
      }

      .bet-btn {
        min-width: 1.87rem;
        height: .8rem;
        padding: 0 .2rem;
        background: #2C6EF6;
        border-radius: .4rem;
        color: #F1F1F1;
        font-size: 0.37rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: .27rem;
      }
    }
  }

  .overlay-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0, .7);
    z-index: 8;
  }
  .overlay-bg-white {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .7);
    z-index: 8;
  }
  .scratch-box {
    background: #000;
    border: .02rem solid #3a4760;
    border-radius: .6rem;
    padding: 0.64rem .43rem .56rem;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    transform: translate(-50%, -50%);
    z-index: 10;
    overflow: hidden;
    .game-result-tips {
      font-family: HYYakuHei, HYYakuHei;
      font-size: 0.48rem;
      background: linear-gradient(to right, #007AFF 0%, #FFFFFF 60%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .eraser {
      height: 2.91rem;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0.02rem solid #434444;
      margin-top: .53rem;
      font-size: .43rem;
      .scratch-card {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .text {
        width: .86rem;
        height: .86rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        font-size: 0.43rem;
        margin: 0 .15rem;
      }
      .type {
        font-size: .35rem;
      }
      .green-bg {
        background: linear-gradient( 180deg, #00E137 0%, #00C400 47%, #00DC00 100%);
      }
      .red-bg {
        background: linear-gradient( 180deg, #FF5861 0%, #EC2627 47%, #FB3E38 100%);
      }
      .blue-bg {
        background: linear-gradient( 180deg, #99CFFF 0%, #7D9BFD 47%, #388BF6 100%);
      }
    }
    .curren-num {
      font-size: 0.43rem;
      color: #A8D3FF;
      margin-top: .53rem;
    }
    .next-time {
      font-size: .53rem;
      margin: .53rem 0 .11rem;
      span {
        color: #FFC800;
        font-size: .69rem;
        margin: 0 .12rem;
        font-family: Gilroy-Medium;
      }
    }
    .time-title {
      color: #9A9A9A;
      font-size: .43rem;
    }
    .btn {
      height: 1.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #007AFF;
      margin-top: .37rem;
      font-weight: 600;
      font-size: 0.43rem;
      &.back-btn {
        background: #FF905F;
        margin-top: .27rem;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/game/room.vue